module.exports = __webpack_public_path__ + "img/system@2x (3).01dd83b7.png";